import { Grid } from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';
import { CambridgeProduct } from '../../types';
import Product from './Product';

interface IProducts {
  products: CambridgeProduct[];
}

const Products: React.FC<IProducts> = ({ products }) => (
  <Grid container>
    {products.map((product, index) => (
      <Grid item key={index} xs={12} sm={6} md={4} lg={4} xl={4}>
        <Product key={product.title} {...product} />
      </Grid>
    ))}
  </Grid>
);

export default hot(memo(Products));
